import type { ISwSettings } from "app/@types/ISwSettings";

/** Same semantics as usersUtils.isAfterTrial — kept in app/common for boundary compliance. */
export const isAfterTrialFromHomeResources = (swSettings: ISwSettings): boolean =>
    !!swSettings.components.Home?.resources.IsAfterTrial;

/** Same semantics as usersUtils.isAfterTrialCC — kept in app/common for boundary compliance. */
export const isAfterTrialCCFromQuiz = (swSettings: ISwSettings): boolean =>
    !!swSettings?.user?.customData?.quiz?.ShouldGoToAfterTrial;
